/** Orientarea inelelor hărții, fără three.js: o folosesc și geometria machetei
 *  (`geometrie.ts`), și desenul 2D (`desen2d.ts`). OSM scrie conturul și
 *  curțile în orice sens; amândouă au nevoie de conturul trigonometric și de
 *  curți invers — macheta ca pereții să iasă spre afară, planul ca regula
 *  `nonzero` să golească curțile fără să golească și suprapunerile. */

import type { Inel } from "./tipuri";

export const ariaSemn = (inel: Inel): number => {
  let a = 0;
  for (let i = 0, j = inel.length - 1; i < inel.length; j = i++) {
    a += inel[j][0] * inel[i][1] - inel[i][0] * inel[j][1];
  }
  return a / 2;
};

/** Inelul fără ultimul punct dublat, orientat cum se cere. */
export function orientat(inel: Inel, trigonometric: boolean): Inel {
  let r = inel;
  const u = r[r.length - 1];
  if (r.length > 1 && u[0] === r[0][0] && u[1] === r[0][1]) r = r.slice(0, -1);
  return (ariaSemn(r) > 0) === trigonometric ? r : r.slice().reverse();
}
